import React, { useState, useEffect } from 'react'
import BrandList from '../components/BrandList'
import BannerProduct from '../components/BannerProduct'
import HorizontalCardProduct from '../components/HorizontalCardProduct'
import VerticalCardProduct from '../components/VerticalCardProduct'

import CropSection from '../components/CropSection'
import RecentlyViewed from '../components/RecentlyViewed'
import SummaryApi from '../common'
import service from '../common/HttpService'

const Home = () => {
    const [categories, setCategories] = useState([])
    const [loadingCategories, setLoadingCategories] = useState(true)

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await service.get(SummaryApi.getCategory.url)
                if (response?.status === "1" || response?.success === "true" || response?.success === true) {
                    const cats = response?.extraData?.category || response?.data || []
                    setCategories(cats)
                }
            } catch (err) {
                console.error("Error fetching categories on homepage:", err)
            } finally {
                setLoadingCategories(false)
            }
        }
        fetchCategories()
    }, [])

    return (
        <div className='overflow-x-hidden'>
            <div>
                <BannerProduct />
            </div>

            <div>
                <HorizontalCardProduct heading={"BEST SELLERS"} />
            </div>

            <div>
                <HorizontalCardProduct heading={"Today's Offer"} />
            </div>

            <div>
                <CropSection />
            </div>
            <div>

            </div>
            <div>
                <BrandList />
            </div>


            <div className='flex flex-col gap-0'>
                {loadingCategories ? (
                    [1, 2, 3].map((i) => (
                        <div key={i} className="container mx-auto px-4 my-6">
                            <div className="h-6 w-48 shimmer-effect rounded mb-4"></div>
                            <div className="flex gap-4 overflow-x-hidden">
                                {[1, 2, 3, 4].map((j) => (
                                    <div key={j} className="w-full min-w-[210px] md:min-w-[245px] max-w-[210px] md:max-w-[245px] bg-white rounded-2xl shadow-sm overflow-hidden border border-slate-50">
                                        <div className="shimmer-effect h-44 w-full"></div>
                                        <div className="p-4 space-y-3">
                                            <div className="h-4 shimmer-effect rounded w-3/4"></div>
                                            <div className="h-3 shimmer-effect rounded w-1/2"></div>
                                            <div className="flex justify-between items-center pt-2">
                                                <div className="h-5 shimmer-effect rounded w-1/3"></div>
                                                <div className="h-8 shimmer-effect rounded-lg w-1/3"></div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    categories.map((cat) => {
                        const catName = cat.category || cat.name || "";
                        if (!catName) return null;
                        return (
                            <div key={cat.id || cat._id || catName}>
                                <VerticalCardProduct
                                    heading={catName}
                                    category={catName}
                                    categoryId={cat.id || cat._id}
                                />
                            </div>
                        )
                    })
                )}
            </div>



            <div>
                <RecentlyViewed />
            </div>
            {/* <MobileAppBanner /> */}
        </div>
    )
}

export default Home